// Drop the query string and fragment from a URL, keeping scheme + host + path.
// Datadog RUM and Sentry both record fetch/XHR and view/navigation URLs, and
// our API client serializes user-entered `search` terms (e.g. a client or
// caregiver name) into query params. We only need the endpoint/view path for
// per-endpoint latency, so strip everything from the first '?' or '#'.
export function stripQuery(url: string): string {
    const separatorIndex = url.search(/[?#]/);
    return separatorIndex === -1 ? url : url.slice(0, separatorIndex);
}
